import React, { useState, useEffect, createContext, useRef, useCallback } from "react";
import BgForm from "../../images/bg-form.png";
import {
  Input,
  Button,
  Form,
  Radio,
  Select,
  Checkbox,
  notification,
  Row,
  Col,
  Modal,
  Collapse,
  Drawer,
  Tag,
  DatePicker,
} from "antd";
import { CaretUpOutlined, CaretDownOutlined } from "@ant-design/icons";
import { CloseOutlined, TagOutlined } from "@ant-design/icons";
import $axios from "../../services/axios";
import { checkRepayment } from "../../helpers/utils";
import moment from "moment";
import dayjs from "dayjs";
import _ from "lodash";
import ConfirmModal from "../Common/ConfirmModal";
import locale from "antd/es/date-picker/locale/vi_VN";
import isBetween from "dayjs/plugin/isBetween";
import RepaymentModal from "../../components/Common/RepaymentModal";

dayjs.extend(isBetween);
const ReachableContext = createContext(null);
const { Option } = Select;
const { TextArea } = Input;

const Step3 = ({
  onChangeStep,
  onChangeBookingInfo,
  chooseFlight,
  setLoading,
  setStep,
  airports,
  setChooseFlight,
  setFilterDay,
  setChoosingStep
}) => {
  // Check if any flight has isSameDayTicket = true
  const hasSameDayTicket = useCallback(() => {
    return _.some(chooseFlight, f => f.isSameDayTicket === true);
  }, [chooseFlight]);

  // State for countdown timer
  const [countdown, setCountdown] = useState(15 * 60); // 15 minutes in seconds
  const [showSameDayNotification, setShowSameDayNotification] = useState(false);
  const [isSameDayTicketFlight, setIsSameDayTicketFlight] = useState(false);
  const countdownRef = useRef(null);

  // Check if current flight is same day ticket
  const currentIsSameDay = hasSameDayTicket();
  
  // Set isSameDayTicketFlight state based on flights
  useEffect(() => {
    setIsSameDayTicketFlight(currentIsSameDay);
  }, [currentIsSameDay]);

  console.log(chooseFlight, "chooseFlight");
  const [modal, contextHolder] = Modal.useModal();
  const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
  const [isModalConfirm, setIsModalConfirm] = useState(false);
  const formRef = useRef(null);
  const config = {
    title: "Thông báo!",
    maskClosable: false,
    closable: false,
    footer: [
      <div className="text-center w-full">
        <Button
          key="ok"
          type="primary"
          onClick={() => (window.location.href = "/vemaybay")}
          className="text-white"
        >
          Về trang tìm kiếm
        </Button>
      </div>,
    ],
    content: (
      <>
        <ReachableContext.Consumer>
          {() => (
            <div className="text-[14px] text-[#0D1634] font-medium">
              Chuyến bay đã có sự thay đổi về giá. Vui lòng tìm kiếm lại chuyến
              bay để cập nhật!
            </div>
          )}
        </ReachableContext.Consumer>
        <br />
      </>
    ),
  };
  const configNotAvailable = {
    title: "Thông báo!",
    maskClosable: false,
    closable: false,
    footer: [
      <div className="text-center w-full">
        <Button
          key="ok"
          type="primary"
          onClick={() => {
            onChangeBookingInfo({});
            setStep((prev) => prev - 2);
            setChooseFlight([]);
            setFilterDay("");
            setChoosingStep(1);
          }}
          className="text-white"
        >
          Về trang tìm kiếm
        </Button>
      </div>,
    ],
    content: (
      <>
        <ReachableContext.Consumer>
          {() => (
            <div className="text-[14px] text-[#0D1634] font-medium">
              Chuyến bay bạn chọn hiện không còn ghế trống hoặc giá vé đã thay
              đổi. Vui lòng tìm chuyến bay khác.!
            </div>
          )}
        </ReachableContext.Consumer>
        <br />
      </>
    ),
  };
  const [form] = Form.useForm();
  const invoice = Form.useWatch("invoice", form);
  const [baggages, setBaggages] = useState([]);
  const [baggagesOut, setBaggagesOut] = useState([]);
  const [passengerIdChoose, setPassengerIdChoose] = useState(null);
  const [voucherValue, setVoucherValue] = useState(0);
  const [voucherCode, setVoucherCode] = useState("");
  const [voucherTxt, setVoucherTxt] = useState("");
  const FlightType = _.some(chooseFlight, f => !f.isdomestic) ? "international" : "domestic";
  const [showPriceDetail, setShowPriceDetail] = useState(false);
  const [bodyBooking, setBodyBooking] = useState(null);
  const [unpaidBookings, setUnpaidBookings] = useState([]);
  const [totalListPrice, setTotalListPrice] = useState({
    totalFixed: 0,
    baggage: 0,
    baggage_out: 0,
    totalDisplay: 0,
    totalpriceAdd: 0,
  });
  //mã giảm giá
  const [openVoucher, setOpenVoucher] = useState(false);
  const [vouchers, setVouchers] = useState([]);
  const [openRepaymentModal, setOpenRepaymentModal] = useState(true);
  const [dataRepayment, setDataRepayment] = useState(null);
  const departureDate = dayjs(
    chooseFlight?.[0]?.options?.[0]?.flights?.[0]?.startdate
  );

  const DOB_RANGE = {
    INF: {
      min: departureDate.clone().subtract(2, "year").add(1, "day"),
      max: departureDate.clone(),
    },
    CHD: {
      min: departureDate.clone().subtract(12, "year").add(1, "day"),
      max: departureDate.clone().subtract(2, "year"),
    },
  };

  const getMonths = () => {
    return _.range(1, 13).map((m) => String(m).padStart(2, "0"));
  };

  const getDays = () => {
    return _.range(1, 32).map((d) => String(d).padStart(2, "0"));
  };

  const getValidYearsByDayMonth = (type, day, month) => {
    if (!day || !month) return [];

    const { min, max } = DOB_RANGE[type];

    return _.range(min.year(), max.year() + 1).filter((year) => {
      const dob = dayjs(`${year}-${month}-${day}`, "YYYY-MM-DD", true);

      return dob.isBetween(min, max, "day", "[]");
    });
  };

  const validateAndResetYearIfInvalid = (p) => {
    const day = form.getFieldValue(`day_${p.id}`);
    const month = form.getFieldValue(`month_${p.id}`);
    const year = form.getFieldValue(`year_${p.id}`);

    if (!day || !month || !year) return;

    const validYears = getValidYearsByDayMonth(p.Type, day, month);

    if (!validYears.includes(year)) {
      form.setFieldsValue({
        [`year_${p.id}`]: undefined,
      });
    }
  };

  const fetchUnpaidOrder = async () => {
    const end = dayjs();
    const start = end.subtract(2, "day");
    const startTime = start.format("DD/MM/YYYY");
    const endTime = end.format("DD/MM/YYYY");
    try {
      const res = await $axios.$get(
        `/order-flight/findByAllUser?startdate=${startTime}&enddate=${endTime}&page=${1}&pageSize=100`
      );
      const histories = res.data.data.data;
      if (histories.length > 0) {
        const bookings = histories.filter(h => checkRepayment(h?.createdat) && h?.paymentstatus === "PayLater" && h?.status === "Create");
        if (bookings.length > 0) {
          setUnpaidBookings(bookings);
        }
      }
    } catch (error) {
    } finally {
    }
  };

  const ListPassengerAdt =
    _.get(chooseFlight, "[0].adt", 0) > 0
      ? _.range(1, _.get(chooseFlight, "[0].adt", 0) + 1).map((item) => {
        const id = `adt-${item}`;
        return {
          id,
          FirstName: "",
          LastName: "",
          Type: "ADT", // loại khách ADT, CHD, INF
          Number: "",
          PassportNumber: "",
          Gender: "male",
          Membership: "",
          Birthday: "",
          ListBaggage: [],
          ListSeat: [],
        };
      })
      : [];

  const ListPassengerChd =
    _.get(chooseFlight, "[0].chd", 0) > 0
      ? _.range(1, _.get(chooseFlight, "[0].chd", 0) + 1).map((item) => {
        return {
          id: `chd-${item}`,
          FirstName: "",
          LastName: "",
          Type: "CHD", // loại khách ADT, CHD, INF
          IdCard: "",
          PassportNumber: "",
          Gender: "male",
          Membership: "",
          Birthday: "",
          ListBaggage: [],
          ListSeat: [],
        };
      })
      : [];

  const ListPassengerInf =
    _.get(chooseFlight, "[0].inf", 0) > 0
      ? _.range(1, _.get(chooseFlight, "[0].inf", 0) + 1).map((item) => {
        return {
          id: `inf-${item}`,
          FirstName: "",
          LastName: "",
          Type: "INF",
          IdCard: "",
          PassportNumber: "",
          Gender: "male",
          Membership: "",
          Birthday: "",
          ListBaggage: [],
          ListSeat: [],
        };
      })
      : [];

  const ListPassenger = _.concat(
    ListPassengerAdt,
    ListPassengerChd,
    ListPassengerInf
  ).map((item, index) => {
    item.Index = index + 1;
    return item;
  });

  // Cleanup countdown on unmount
  useEffect(() => {
    return () => {
      if (countdownRef.current) {
        clearInterval(countdownRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (ListPassenger.length > 0) {
      setPassengerIdChoose(ListPassenger[0].id);
    }
    fetchUnpaidOrder();
  }, []);

  // Show notification and start countdown when entering step 3 for same-day tickets
  useEffect(() => {
    if (isSameDayTicketFlight) {
      // Show warning notification
      notification.warning({ 
        message: "Quý khách vui lòng thanh toán trong 15 phút để giữ chỗ cho vé bay trong ngày.", duration: 0, // Keep showing until closed
        onClose: () => {
          setShowSameDayNotification(true);
        }
      });

      // Start countdown timer
      setCountdown(15 * 60);
      
      countdownRef.current = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(countdownRef.current);
            // Time expired - return to step 1
            notification.error({
              message: "Đã hết hạn thời gian thanh toán. Quý khách vui lòng tìm kiếm lại chuyến bay.",
              duration: 3
            });
            // Redirect to search page
            onChangeBookingInfo({});
            setStep(1);
            setChooseFlight([]);
            setFilterDay("");
            setChoosingStep(1);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    // Reset notification flag when non-same-day flight
    else {
      setShowSameDayNotification(false);
    }
  }, [isSameDayTicketFlight]);

  const initialValues = _.reduce(
    ListPassenger,
    (acc, num, index) => {
      acc[`gender_${num.id}`] = "male";
      if (index === 0) {
        acc[`surname_${num.id}`] = _.head(_.split(userInfo?.name, " "))?.normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .replace(/đ/g, "d")
          .replace(/Đ/g, "D")
          .toUpperCase();
        acc[`lastName_${num.id}`] = _.join(
          _.tail(_.split(userInfo?.name, " ")),
          " "
        )?.normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .replace(/đ/g, "d")
          .replace(/Đ/g, "D")
          .toUpperCase();
      }
      return acc;
    },
    {
      genderContact: "male",
      phone: userInfo?.phone,
      email: userInfo?.email,
      surnameContact: _.head(_.split(userInfo?.name, " "))
        ?.normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/đ/g, "d")
        .replace(/Đ/g, "D")
        .toUpperCase(),
      lastNameContact: _.join(_.tail(_.split(userInfo?.name, " ")), " ")
        ?.normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/đ/g, "d")
        .replace(/Đ/g, "D")
        .toUpperCase(),
    }
  );

  // Handle back button click - return to step 1 immediately (only for same-day ticket flights)
  const handleBackClick = useCallback(() => {
    if (isSameDayTicketFlight) {
      clearInterval(countdownRef.current);
      onChangeBookingInfo({});
      setStep(1);
      setChooseFlight([]);
      setFilterDay("");
      setChoosingStep(1);
    } else {
      // For non-same-day ticket flights, just go back to previous step
      setStep((prev) => prev - 1);
    }
  }, [isSameDayTicketFlight, onChangeBookingInfo, setStep, setChooseFlight, setFilterDay, setChoosingStep]);

  const verifyFlight = async () => {
    setLoading(true);
    let dataVerify = {
      verifySession: [],
      flightvalues: [],
    };
    try {
      const requests = chooseFlight.map(async (flight) => {
        try {
          const body = {
            System: flight?.airline?.code,
            IsUpSell: false,
            flightvalues: [flight?.options?.[0]?.flights?.[0].flightvalue],
          };
          const res = await $axios.$post("/honghatrip/select", body);
          if (res.data.statuscode === 200) {
            const faredatas = res.data?.data?.faredatas;
            if (_.some(faredatas, fare => _.some(fare.options[0].flights, f => _.some(f.segments, s => s.seatAvl === 0)))) {
              throw new Error("Lỗi xác thực chuyến bay");
            }
            dataVerify.verifySession.push({
              value: res.data.data.session || "",
              startpoint: flight?.options?.[0]?.flights?.[0].startpoint,
            });
            dataVerify.flightvalues.push({
              value:
                res.data.data.faredatas?.[0]?.options?.[0]?.flights?.[0]
                  ?.flightValue || "",
              startpoint: flight?.options?.[0]?.flights?.[0].startpoint,
            });
          }
        } catch (error) {
          throw new Error("Lỗi xác thực chuyến bay");
        }
      });
      await Promise.all(requests);
    } catch (error) {
      throw error;
    } finally {
      setLoading(false);
    }
    return dataVerify;
  };

  const getPassengers = (values, indexFlight) => {
    const _ListPassenger = ListPassenger.map((p, index) => {
      p.FirstName = values[`surname_${p.id}`];
      p.LastName = values[`lastName_${p.id}`];
      p.Gender = values[`gender_${p.id}`] === "male" ? true : false;

      let baggage = [];
      if (indexFlight === 0) { // chiều đi
        baggage = baggages.filter(
          (b) => b.code === values[`baggage_${p.id}`]
        );
      }
      else { //chiều về
        baggage = baggagesOut.filter(
          (b) => b.code === values[`baggage_out_${p.id}`]
        );
      }
      p.ListBaggage = baggage
      return {
        Index: index,
        SurName: p.FirstName,
        GivenName: p.LastName,
        Title:
          p.Type === "ADT"
            ? p.Gender
              ? "MR"
              : "MS"
            : p.Gender
              ? "MSTR"
              : "MSTR",
        Gender: p.Gender,
        Type: p.Type,
        Baggages: p.ListBaggage.map((b) => b?.prices?.[0]?.value),
        Ancillaries: [],
        SeatMaps: [],
        Memberships: [],
        DateOfBirth:
          p.Type === "ADT"
            ? "1990-01-01"
            : `${values[`year_${p.id}`]}-${values[`month_${p.id}`]}-${values[`day_${p.id}`]
            }`,
        Document: {
          SurName: p.FirstName,
          GivenName: p.LastName,
          DateOfBirth:
            p.Type === "ADT"
              ? "1990-01-01"
              : `${values[`year_${p.id}`]}-${values[`month_${p.id}`]}-${values[`day_${p.id}`]
              }`,
          Gender: p.Gender,
          // Number: values[`number_${p.id}`] || null,
          // Type: values[`type_${p.id}`] || null,
          // National: values[`national_${p.id}`] || null,
          // ExpiryDate:
          //   dayjs(values[`expiryDate_${p.id}`]).format("YYYY-MM-DD") || null,
          // IssueCountry: values[`national_${p.id}`] || null,
          // IssueDate:
          //   dayjs(values[`issueDate_${p.id}`]).format("YYYY-MM-DD") || null,
          Number: "012345678900",
          Type: "I",
          National: "VNM",
          ExpiryDate: "2035-12-30",
          IssueCountry: "VNM",
          IssueDate: "2025-12-30",
        },
      };
    });

    return _ListPassenger;
  }

  const getPointInfo = (point) => {
    return airports?.find(
      (item) =>
        item.code ===
        point
    )?.name
  }
  // Format countdown time
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  const handleFinish = async (values) => {
    try {
      const dataVerify = await verifyFlight();
      // NOTE: check giá xem có được booking hay không
      if (dataVerify.verifySession.length !== chooseFlight.length) {
        await modal.confirm(config);
        return;
      }
      const body = {
        ContactEmail: values.email,
        ContactPhone: values.phone,
        ContactFullName: values.surnameContact + " " + values.lastNameContact,
        ContactGender: values.genderContact === "male" ? true : false,
        Amount: totalListPrice.totalDisplay,
        AmountOriginal: totalListPrice.totalDisplay + voucherValue,
        VoucherCode: voucherCode || "",
        AmountOtherIpass: totalListPrice.totalpriceAdd,
        Recovery: chooseFlight.length > 1 ? 1 : 0,
        TypeFlight: FlightType,
        Bookings: chooseFlight.map((flight, index) => {
          const flightvalue =
            _.find(dataVerify.flightvalues, {
              startpoint: flight?.options?.[0]?.flights?.[0].startpoint,
            })?.value || flight?.options?.[0]?.flights?.[0].flightvalue;
          const verifySession =
            _.find(dataVerify.verifySession, {
              startpoint: flight?.options?.[0]?.flights?.[0].startpoint,
            })?.value || null;

          return {
            System: flight?.airline?.code,
            VerifySession: verifySession,
            BookType: "normal",
            flightvalues: [flightvalue],
            AutoIssue:
              FlightType === "domestic" ? flight.isSameDayTicket : false,
            StartDate: flight?.options?.[0]?.flights?.[0].startdate,
            EndDate: flight?.options?.[0]?.flights?.[0].enddate,
            FlightValuesSearch: [
              flight?.options?.[0]?.flights?.[0].flightvalue,
            ],
            Passengers: getPassengers(values, index),
            Airline: flight?.airline?.code,
            StartPoint: flight?.options?.[0]?.flights?.[0].startpoint,
            EndPoint: flight?.options?.[0]?.flights?.[0].endpoint,
            FareClass:
              flight?.options?.[0]?.flights?.[0]?.segments?.[0]?.fareclass,
            FlightNumber:
              flight?.options?.[0]?.flights?.[0]?.segments?.[0]?.flightnumber,
          };
        }),
        InfoOrder: JSON.stringify({
          Service: "flight",
          Sponsor: "IPASS",
          VoucherCode: voucherCode || "",
          VoucherValue: voucherValue || 0,
          DepartureInfo: {
            StartDate: chooseFlight[0]?.options?.[0]?.flights?.[0].startdate,
            StartPoint: getPointInfo(
              chooseFlight[0]?.options?.[0]?.flights?.[0].startpoint,
            ),
            EndPoint: getPointInfo(
              chooseFlight[0]?.options?.[0]?.flights?.[0].endpoint,
            ),
            FlightNumber:
              `${chooseFlight[0]?.airline?.code} ${chooseFlight[0]?.options?.[0]?.flights?.[0]?.segments?.[0]?.flightnumber}`,
            PriceAdt: chooseFlight[0]?.priceadt,
            PriceChd: chooseFlight[0]?.pricechd,
            PriceInf: chooseFlight[0]?.priceinf,
            TotalTax: chooseFlight[0]?.totaltax,
            Baggage: totalListPrice.baggage
          },
          ArriveInfo:
            chooseFlight.length > 1
              ? {
                StartDate:
                  chooseFlight[1]?.options?.[0]?.flights?.[0].startdate,
                StartPoint: getPointInfo(
                  chooseFlight[1]?.options?.[0]?.flights?.[0].startpoint,
                ),
                EndPoint: getPointInfo(
                  chooseFlight[1]?.options?.[0]?.flights?.[0].endpoint,
                ),
                FlightNumber:
                  `${chooseFlight[1]?.airline?.code} ${chooseFlight[1]?.options?.[0]?.flights?.[0]?.segments?.[0]?.flightnumber}`,
                PriceAdt: chooseFlight[1]?.priceadt,
                PriceChd: chooseFlight[1]?.pricechd,
                PriceInf: chooseFlight[1]?.priceinf,
                TotalTax: chooseFlight[1]?.totaltax,
                Baggage: totalListPrice.baggage_out
              }
              : {},
          PassengersInfo: ListPassenger.map((p) => {
            return {
              SurName: p.FirstName,
              GivenName: p.LastName,
            };
          }),
          Amount: totalListPrice.totalDisplay,
          InvoiceInfo: invoice
            ? {
              VatPhone: values.phone,
              VatFullName: values.receiverReceive,
              VatEmail: values.email,
            }
            : {},
        }),
      };
      if (invoice) {
        body.VatMst = values.taxCode;
        body.VatFullName = values.receiverReceive;
        body.VatEmail = values.email;
      };
      setBodyBooking(body);
      const dupBooking = getDuplicateBooking(body);
      // console.log(dupBooking,'dupBooking');

      if (dupBooking) {
        setDataRepayment(dupBooking);
        setOpenRepaymentModal(true);
      }
      else {
        setIsModalConfirm(true);
      }
    } catch (error) {
      console.log(error, 'error 1');
      if (error?.message === "Lỗi xác thực chuyến bay") {
        onChangeBookingInfo({});
        setStep((prev) => prev - 2);
        setChooseFlight([]);
        setFilterDay("");
        setChoosingStep(1);
        notification.error({
          status: "error",
          message: "Thất bại",
          description: "Lỗi xác thực chuyến bay",
        });
        return;
      }
      notification.error({
        status: "error",
        message: "Thất bại",
        description: error?.response?.data?.message || error?.response?.data?.err || "Đã có lỗi xảy ra!",
      });
    } finally {
    }
  };

  const getDuplicateBooking = (booking) => {
    // console.log(booking,'booking');
    // console.log(unpaidBookings, 'unpaidBookings');
    const dupBooking = _.find(unpaidBookings, b => {
      let isVerifyFlight = true;
      // check số lượng vé
      if (b.orderplanebookings.length !== booking.Bookings.length) {
        isVerifyFlight = false;
      }
      // console.log(b.orderplanepassengers, 'orderplanepassengers');
      const Passengers = booking.Bookings[0].Passengers;
      // check 
      _.forEach(b.orderplanebookings, (item, index) => {
        const startpoint = chooseFlight[index]?.options[0]?.flights[0]?.startpoint;
        const endpoint = chooseFlight[index]?.options[0]?.flights[0]?.endpoint;
        const startdate = chooseFlight[index]?.options[0]?.flights[0]?.startdate;
        const enddate = chooseFlight[index]?.options[0]?.flights[0]?.enddate;
        const airline = chooseFlight[index]?.airline.code;
        // console.log(item.fromairport !== startpoint,'item.fromairport !== startpoint');
        // console.log( item.toairport !== endpoint, ' item.toairport !== endpoint');
        // console.log(item.airline !== airline,'item.airline !== airline');
        // console.log(!moment(item.departuretime).isSame(startdate),'!moment(item.departuretime).isSame(startdate)');
        // console.log( !moment(item.arrivaltime).isSame(enddate),' !moment(item.arrivaltime).isSame(enddate)');

        if (item.fromairport !== startpoint || item.toairport !== endpoint || item.airline !== airline || !moment(item.departuretime).isSame(startdate) || !moment(item.arrivaltime).isSame(enddate)) {
          isVerifyFlight = false;
        }
      })
      const isSamePassager = _.every(Passengers, p1 =>
        _.some(b.orderplanepassengers, p2 => p2.surname === p1.SurName && p2.givenname === p1.GivenName && p2.title === p1.Title && p2.passengertype === p1.Type)
      );
      // console.log(isSamePassager,'isSamePassager');
      // console.log(isVerifyFlight,'isVerifyFlight');
      // console.log(b.fullnamecontact === booking.ContactFullName && b.emailcontact === booking.ContactEmail && b.amount === booking.Amount && b.phonecontact === booking.ContactPhone,'222');
      return b.fullnamecontact === booking.ContactFullName && b.emailcontact === booking.ContactEmail && b.amount === booking.Amount && b.phonecontact === booking.ContactPhone && isVerifyFlight && isSamePassager;
    })
    return dupBooking;
  }

  const handlePayment = async () => {
    setLoading(true);
    try {
      onChangeBookingInfo({
        ...bodyBooking,
        totalListPrice,
      });
      const res = await $axios.$post(
        "/honghatrip/payment-required",
        bodyBooking
      );
      if (res.data.statuscode === 200) {
        onChangeBookingInfo({
          ...bodyBooking,
          totalListPrice,
          orderId: res?.data?.data?.ordercode,
        });
        onChangeStep(4);
      } else {
        console.log("đã có lỗi ở đây");
        notification.error({
          status: "error",
          message: "Thất bại",
          description: "Đã có lỗi xảy ra!",
        });
      }
    } catch (error) {
      console.log(error, "error 1");
      if (error?.response?.data?.statuscode === 410) {
        setLoading(false);
        await modal.confirm(configNotAvailable);
        return;
      }
      notification.error({
        status: "error",
        message: "Thất bại",
        description: error?.response?.data?.message || error?.response?.data?.err || "Đã có lỗi xảy ra!",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getBaggage();
    if (chooseFlight.length > 0) {
      setTotalListPrice({
        totalFixed: _.sum(_.map(chooseFlight, (f) => f.totalprice)),
        baggage: 0,
        baggage_out: 0,
        totalDisplay: _.sum(_.map(chooseFlight, (f) => f.totalprice)),
        totalpriceAdd:
          _.sum(_.map(chooseFlight, (f) => f.totalprice)) -
          _.sum(_.map(chooseFlight, (f) => f.totalpriceroot)),
        totalOriginal: _.sum(_.map(chooseFlight, (f) => f.totalpriceroot)),
      });
    }
  }, []);

  useEffect(() => {
    if (totalListPrice.totalFixed > 0) {
      getVouchers();
    }
  }, [totalListPrice.totalFixed]);

  const getVouchers = async () => {
    setLoading(true);
    try {
      const res = await $axios.$post("/voucher/getVoucherByOrder", {
        Quantity: ListPassenger.length,
        Total:
          totalListPrice.totalFixed +
          totalListPrice.baggage +
          totalListPrice.baggage_out,
        TypeFight: FlightType,
      });
      const now = moment();
      const validVouchers = res.data.data.filter((voucher) => {
        const start = moment(voucher.startdate);
        const end = moment(voucher.enddate);
        return now.isBetween(start, end, null, "[]"); // [] để bao gồm cả thời gian bắt đầu và kết thúc
      });
      setVouchers(validVouchers);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (passengerIdChoose) {
      handleChangeContactPersion();
    }
  }, [passengerIdChoose]);

  const handleInputChange = (e, field) => {
    let inputValue = e.target.value;

    // Chỉ lấy từ đầu tiên cho các trường surname
    if (field.startsWith("surname_") || field === "surnameContact") {
      inputValue = inputValue.split(" ")[0]; // Lấy từ đầu tiên
    }

    const uppercaseValue = inputValue
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/đ/g, "d")
      .replace(/Đ/g, "D")
      .toUpperCase();

    form.setFieldsValue({ [field]: uppercaseValue });
  };

  // lấy hành lý
  const getBaggage = async () => {
    setLoading(true);
    try {
      const resIn = await $axios.$post("/honghatrip/getbaggages", {
        System: chooseFlight[0]?.airline.code,
        Airline: chooseFlight[0]?.airline.code,
        flightvalue: chooseFlight?.[0]?.options?.[0]?.flights?.[0].flightvalue,
      });
      setBaggages(_.get(resIn, "data.data.baggages", []));
      if (chooseFlight.length === 2) {
        const resOut = await $axios.$post("/honghatrip/getbaggages", {
          System: chooseFlight[1]?.airline.code,
          Airline: chooseFlight[1]?.airline.code,
          flightvalue:
            chooseFlight?.[1]?.options?.[0]?.flights?.[0].flightvalue,
        });
        setBaggagesOut(_.get(resOut, "data.data.baggages", []));
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const applyVoucher = async (e) => {
    if (e) {
      setLoading(true);
      try {
        const res = await $axios.$get(`/voucher/getVoucher?voucherCode=${e}`);
        if (res.data.data.status === 1) {
          setVoucherValue(res.data.data.amount);
          setVoucherCode(e);
          setVoucherTxt(
            `<div class="text-[14px] ">Áp dụng mã giảm giá thành công! <span class="text-green-600 text-[16px]">
        ${res.data.data.amount.toLocaleString("vi-VN")} đ</span></div>`
          );
          setTotalListPrice({
            ...totalListPrice,
            totalDisplay:
              totalListPrice.totalFixed +
              totalListPrice.baggage +
              totalListPrice.baggage_out -
              res.data.data.amount,
          });
        } else {
          setVoucherTxt(
            `<div class="text-[14px] text-red-600">Mã giảm giá không hợp lệ! Vui lòng thử lại</div>`
          );
          setVoucherValue(0);
          setVoucherCode("");
          setTotalListPrice({
            ...totalListPrice,
            totalDisplay:
              totalListPrice.totalFixed +
              totalListPrice.baggage +
              totalListPrice.baggage_out,
          });
        }
      } catch (error) {
        setVoucherTxt(
          `<div class="text-[14px] text-red-600">Mã giảm giá không hợp lệ! Vui lòng thử lại</div>`
        );
        setVoucherValue(0);
        setVoucherCode("");
        setTotalListPrice({
          ...totalListPrice,
          totalDisplay:
            totalListPrice.totalFixed +
            totalListPrice.baggage +
            totalListPrice.baggage_out,
        });
      } finally {
        setLoading(false);
      }
    } else {
      setVoucherTxt(
        `<div class="text-[14px] text-red-600">Mã giảm giá không hợp lệ! Vui lòng thử lại</div>`
      );
      setVoucherValue(0);
      setVoucherCode("");
      setTotalListPrice({
        ...totalListPrice,
        totalDisplay:
          totalListPrice.totalFixed +
          totalListPrice.baggage +
          totalListPrice.baggage_out,
      });
    }
  };

  const applyVoucherPick = async (voucher) => {
    let amount = voucher.amountvoucher;
    if (voucher.discounttype === "PERCENTAGE") {
      const amountDiscount = Math.ceil(
        (totalListPrice.totalFixed +
          totalListPrice.baggage +
          totalListPrice.baggage_out) *
        (voucher.discountvalue / 100)
      );
      amount =
        amountDiscount < voucher.maxdiscountvalue
          ? amountDiscount
          : voucher.maxdiscountvalue;
    }
    setVoucherValue(amount);
    setVoucherCode(voucher.code);
    setVoucherTxt(
      `<div class="text-[14px] ">Áp dụng mã giảm giá thành công! <span class="text-green-600 text-[16px]">
  ${amount.toLocaleString("vi-VN")} đ</span></div>`
    );
    setTotalListPrice({
      ...totalListPrice,
      totalDisplay:
        totalListPrice.totalFixed +
        totalListPrice.baggage +
        totalListPrice.baggage_out -
        amount,
    });
    setOpenVoucher(false);
  };

  const handleChangeContactPersion = () => {
    form.setFieldsValue({
      surnameContact: form.getFieldValue(`surname_${passengerIdChoose}`),
      lastNameContact: form.getFieldValue(`lastName_${passengerIdChoose}`),
      genderContact: form.getFieldValue(`gender_${passengerIdChoose}`),
    });
  };

  const handleValuesFormChange = (changedValues, allValues) => {
    let totalBaggage = 0;
    let totalBaggageOut = 0;
    let totalBaggageIn = 0;
    const all_baggages = [...baggages, ...baggagesOut];
    Object.keys(allValues).forEach((key) => {
      if (key.includes("baggage_")) {
        totalBaggage += _.get(
          _.find(all_baggages, (b) => b.code === allValues[key]),
          "prices.[0].price",
          0
        );
      }
      if (key.includes("baggage_out_")) {
        totalBaggageOut += _.get(
          _.find(baggagesOut, (b) => b.code === allValues[key]),
          "prices.[0].price",
          0
        );
      }
    });
    totalBaggageIn = totalBaggage - totalBaggageOut;
    setTotalListPrice({
      ...totalListPrice,
      baggage: totalBaggageIn,
      baggage_out: totalBaggageOut,
      totalDisplay:
        totalListPrice.totalFixed +
        totalBaggageIn +
        totalBaggageOut -
        voucherValue,
    });
  };

  // Render same-day ticket warning banner
  const renderSameDayWarning = () => {
    if (!isSameDayTicketFlight) return null;
    return (
      <div className="bg-yellow-100 border-l-4 border-yellow-500 p-4 mb-4 rounded">
        <div className="flex items-start gap-3">
          <div className="mt-1">
            <svg className="w-6 h-6 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.848c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <div>
            <h3 className="text-yellow-800 font-semibold text-[14px]">
              Lưu ý: Chuyến bay trong ngày
            </h3>
              <p className="text-red-700 text-[14px] mt-1 font-bold">Quý khách còn {formatTime(countdown)} để thanh toán đơn hàng.</p>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="bg-[#F6F6F6] mb-4">
      <div className="bg-primary h-[300px] relative">
        <section className="step-indicator">
          <div className="step step1 actived">
            <div className="step-icon" onClick={() => onChangeStep(1)}>
              1
            </div>
            <p>Tìm kiếm</p>
          </div>
          <div className="indicator-line active"></div>
          <div className="step step2 actived">
            <div className="step-icon">2</div>
            <p>Chọn vé</p>
          </div>
          <div className="indicator-line active"></div>
          <div className="step step3 active">
            <div className="step-icon">3</div>
            <p>Thông tin</p>
          </div>
          <div className="indicator-line"></div>
          <div className="step step4">
            <div className="step-icon">4</div>
            <p>Thanh Toán</p>
          </div>
        </section>
        <img src={BgForm} alt="" className="w-full object-cover mx-auto" />
        <div className="flex w-full absolute top-[135px] left-1/2 transform -translate-x-1/2 justify-center gap-8">
          <div className="flex flex-col gap-1">
            <div className="text-white font-semibold text-[18px]">
              {chooseFlight?.[0]?.options?.[0]?.flights?.[0]?.startpoint}
            </div>
            <div className="text-white font-medium text-[11px]">
              {
                airports?.find(
                  (item) =>
                    item.code ===
                    chooseFlight[0].options?.[0]?.flights?.[0]?.startpoint
                )?.namevn
              }{" "}
            </div>
          </div>
          <div className="relative">
            <svg
              width="123"
              height="47"
              viewBox="0 0 123 47"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="text-primary"
            >
              <path
                d="M0 20L5 22.8868V17.1132L0 20ZM123 20L118 17.1132V22.8868L123 20ZM4.5 20.5H118.5V19.5H4.5V20.5Z"
                fill="white"
              />
              <g filter="url(#filter0_d_212_3608)">
                <circle cx="62.5" cy="19.5" r="19.5" fill="white" />
              </g>
              <path
                d="M71.7335 30.404L73.3261 28.1785L68.063 16.3724L72.4426 10.2524C73.1035 9.32878 72.8628 8.06044 71.9037 7.4128C70.9446 6.76516 69.6368 6.9879 68.9759 7.91147L64.5963 14.0316L51.3703 13.3529L49.7777 15.5784L61.013 19.0389L56.6333 25.159L53.1278 25.2675L51.9333 26.9366L56.7741 28.5549L60.0223 32.3987L61.2167 30.7296L60.1 27.4999L64.4797 21.3798L71.7335 30.404Z"
                fill="currentColor"
              />
              <defs>
                <filter
                  id="filter0_d_212_3608"
                  x="39"
                  y="0"
                  width="47"
                  height="47"
                  filterUnits="userSpaceOnUse"
                  colorInterpolationFilters="sRGB"
                >
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_212_3608"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_212_3608"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </div>
          <div className="flex flex-col gap-1">
            <div className="text-white font-semibold text-[18px]">
              {chooseFlight?.[0]?.options?.[0]?.flights?.[0]?.endpoint}
            </div>
            <div className="text-white font-medium text-[11px]">
              {
                airports?.find(
                  (item) =>
                    item.code ===
                    chooseFlight[0].options?.[0]?.flights?.[0]?.endpoint
                )?.namevn
              }{" "}
            </div>
          </div>
        </div>
        <div className="w-[90%] mx-auto absolute top-[200px] left-1/2 transform -translate-x-1/2 pb-[80px] flex flex-col">
          {/* Render same-day warning banner if flight is same day ticket */}
          {renderSameDayWarning()}
          <Form
            ref={formRef}
            layout="vertical"
            form={form}
            onFinish={handleFinish}
            onFinishFailed={(values) => {
              notification.error({
                message: "Thông báo",
                description: "Vui lòng nhập đầy đủ thông tin",
              });
            }}
            autoComplete="off"
            className="formCreateUser"
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            initialValues={initialValues}
            onValuesChange={handleValuesFormChange}
          >
            <div
              style={{
                boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
              }}
              className="rounded-[20px] bg-white p-4 mb-[24px] text-[#0D1634]"
            >
              <div className="text-[20px] font-medium mb-1">
                Thông tin hành khách
              </div>
              <div className="text-[#D72F20] mb-3">(*) là bắt buộc</div>
              {ListPassenger.map((i, index) => (
                <div key={index}>
                  <Form.Item className="mb-2">
                    <div className="flex justify-between">
                      <div className="text-[14px] flex justify-between">
                        {index + 1}.{" "}
                        {i.Type === "ADT"
                          ? "Người lớn"
                          : i.Type === "CHD"
                            ? "Trẻ em"
                            : "Em bé"}
                      </div>
                      {i.Type === "ADT" && (
                        <Checkbox
                          checked={i.id === passengerIdChoose}
                          onChange={(e) => {
                            if (e.target.checked === true) {
                              setPassengerIdChoose(i.id);
                            } else {
                              setPassengerIdChoose(null);
                            }
                          }}
                        >
                          Là người liên hệ
                        </Checkbox>
                      )}
                    </div>
                  </Form.Item>
                  <Form.Item name={`gender_${i.id}`} className="mb-3">
                    <Radio.Group>
                      <Radio value="male" className="text-[14px] font-medium">
                        {i.Type === "ADT" ? "Ông" : "Trai"}
                      </Radio>
                      <Radio value="female" className="text-[14px] font-medium">
                        {i.Type === "ADT" ? "Bà" : "Gái"}
                      </Radio>
                    </Radio.Group>
                  </Form.Item>
                  <Row gutter={8} className="mb-3">
                    <Col span={12}>
                      <Form.Item
                        name={`surname_${i.id}`}
                        label={
                          <div className="text-[14px] font-medium">Họ</div>
                        }
                        rules={[
                          { required: true, message: "Họ không được để trống" },
                        ]}
                        className="mb-0"
                      >
                        <Input
                          placeholder="NGUYEN"
                          onChange={(e) => {
                            handleInputChange(e, `surname_${i.id}`);
                          }}
                          size="middle"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label={
                          <div className="text-[14px] font-medium">
                            Tên đệm & Tên
                          </div>
                        }
                        name={`lastName_${i.id}`}
                        rules={[
                          {
                            required: true,
                            message: "Tên đệm & tên không được để trống",
                          },
                        ]}
                        className="mb-0"
                      >
                        <Input
                          placeholder="VAN A"
                          onChange={(e) => {
                            handleInputChange(e, `lastName_${i.id}`);
                            handleChangeContactPersion();
                          }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  {(i.Type === "CHD" || i.Type === "INF") &&
                    (() => {
                      const year = form.getFieldValue(`year_${i.id}`);
                      const month = form.getFieldValue(`month_${i.id}`);

                      return (
                        <Row gutter={8} className="mb-3">
                          <Col span={8}>
                            <Form.Item
                              name={`day_${i.id}`}
                              label="Ngày sinh"
                              rules={[{ required: true }]}
                            >
                              <Select
                                placeholder="Ngày"
                                onChange={() =>
                                  validateAndResetYearIfInvalid(i)
                                }
                              >
                                {getDays().map((d) => (
                                  <Select.Option key={d} value={d}>
                                    {d}
                                  </Select.Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>

                          <Col span={8}>
                            <Form.Item
                              name={`month_${i.id}`}
                              label="Tháng sinh"
                              rules={[{ required: true }]}
                            >
                              <Select
                                placeholder="Tháng"
                                onChange={() =>
                                  validateAndResetYearIfInvalid(i)
                                }
                              >
                                {getMonths().map((m) => (
                                  <Select.Option key={m} value={m}>
                                    {m}
                                  </Select.Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>

                          <Col span={8}>
                            <Form.Item
                              name={`year_${i.id}`}
                              label="Năm sinh"
                              rules={[{ required: true }]}
                            >
                              <Select placeholder="Năm">
                                {(() => {
                                  const day = form.getFieldValue(`day_${i.id}`);
                                  const month = form.getFieldValue(
                                    `month_${i.id}`
                                  );

                                  if (!day || !month) return null;

                                  return getValidYearsByDayMonth(
                                    i.Type,
                                    day,
                                    month
                                  ).map((y) => (
                                    <Select.Option key={y} value={y}>
                                      {y}
                                    </Select.Option>
                                  ));
                                })()}
                              </Select>
                            </Form.Item>
                          </Col>
                        </Row>
                      );
                    })()}

                  {chooseFlight.length === 1 ? (
                    <>
                      <Form.Item
                        label="+ Hành lý ký gửi"
                        name={`baggage_${i.id}`}
                        className="mb-3"
                      >
                        <Select
                          style={{ width: "100%" }}
                          placeholder="Chọn hành lý ký gửi"
                        >
                          <Option key={-1} value={-1}>
                            Chọn hành lý ký gửi
                          </Option>
                          {baggages.map((item) => (
                            <Option key={item.code} value={item.code}>
                              {item.name} (
                              {item?.prices?.[0]?.price.toLocaleString("vi-VN")}
                              {item?.prices?.[0]?.currency})
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                      {chooseFlight[0].options?.[0]?.flights?.[0]?.segments?.[0]
                        ?.handbaggage && (
                          <Tag className="text-[14px] font-semibold rounded-[20px] px-2 py-1 mb-3 mr-0 bg-primary text-white">
                            Đã bao gồm{" "}
                            {
                              chooseFlight[0].options?.[0]?.flights?.[0]
                                ?.segments?.[0]?.handbaggage
                            }{" "}
                            xách tay
                          </Tag>
                        )}
                    </>
                  ) : (
                    <>
                      <Form.Item
                        label="+ Hành lý ký gửi chiều đi"
                        name={`baggage_${i.id}`}
                        className="mb-3"
                      >
                        <Select
                          style={{ width: "100%" }}
                          placeholder="Chọn hành lý ký gửi"
                        >
                          <Option key={-1} value={-1}>
                            Chọn hành lý ký gửi
                          </Option>
                          {baggages.map((item) => (
                            <Option key={item.code} value={item.code}>
                              {item.name} (
                              {item?.prices?.[0]?.price.toLocaleString("vi-VN")}
                              {item?.prices?.[0]?.currency})
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                      {chooseFlight[0].options?.[0]?.flights?.[0]?.segments?.[0]
                        ?.handbaggage && (
                          <Tag className="text-[14px] font-semibold rounded-[20px] px-2 py-1 mb-3 mr-0 bg-primary text-white">
                            Đã bao gồm{" "}
                            {
                              chooseFlight[0].options?.[0]?.flights?.[0]
                                ?.segments?.[0]?.handbaggage
                            }{" "}
                            xách tay
                          </Tag>
                        )}
                      <Form.Item
                        label="+ Hành lý ký gửi chiều về"
                        name={`baggage_out_${i.id}`}
                        className="mb-3"
                      >
                        <Select
                          style={{ width: "100%" }}
                          placeholder="Chọn hành lý ký gửi"
                        >
                          <Option key={-1} value={-1}>
                            Chọn hành lý ký gửi
                          </Option>
                          {baggagesOut.map((item) => (
                            <Option key={item.code} value={item.code}>
                              {item.name} (
                              {item?.prices?.[0]?.price.toLocaleString("vi-VN")}
                              {item?.prices?.[0]?.currency})
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                      {chooseFlight[1].options?.[0]?.flights?.[0]?.segments?.[0]
                        ?.handbaggage && (
                          <Tag className="text-[14px] font-semibold rounded-[20px] px-2 py-1 mb-3 mr-0 bg-primary text-white">
                            Đã bao gồm{" "}
                            {
                              chooseFlight[1].options?.[0]?.flights?.[0]
                                ?.segments?.[0]?.handbaggage
                            }{" "}
                            xách tay
                          </Tag>
                        )}
                    </>
                  )}

                  {/* <Form.Item label="Chọn ghế" name={`seatmap_${i}`} className="mb-3">
                    <Select style={{ width: "100%" }} placeholder="Chọn ghế">
                      {seatmaps.map((item) => (
                        <Option key={item.Value} value={item.Value}>
                          {item.Name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item> */}
                </div>
              ))}
              <div className="text-[#0D1634] text-[20px] mb-1">
                Thông tin liên hệ
              </div>
              <div className="text-[#D72F20] text-[14px] mb-3">
                (*) là bắt buộc
              </div>
              <Form.Item name="genderContact" className="mb-3">
                <Radio.Group>
                  <Radio value="male" className="text-[14px] font-medium">
                    Ông
                  </Radio>
                  <Radio value="female" className="text-[14px] font-medium">
                    Bà
                  </Radio>
                </Radio.Group>
              </Form.Item>
              <Row gutter={8} className="mb-3">
                <Col span={12}>
                  <Form.Item
                    name="surnameContact"
                    label={<div className="text-[14px] font-medium">Họ</div>}
                    rules={[
                      { required: true, message: "Họ không được để trống" },
                    ]}
                    className="mb-3"
                  >
                    <Input
                      placeholder="NGUYEN"
                      onChange={(e) => handleInputChange(e, "surnameContact")}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label={
                      <div className="text-[14px] font-medium">
                        Tên đệm & Tên
                      </div>
                    }
                    name="lastNameContact"
                    rules={[
                      {
                        required: true,
                        message: "Tên đệm & Tên không được để trống",
                      },
                    ]}
                    className="mb-3"
                  >
                    <Input
                      placeholder="VAN A"
                      onChange={(e) => handleInputChange(e, "lastNameContact")}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={8} className="mb-3">
                <Col span={12}>
                  <Form.Item
                    label="Số điện thoại"
                    name="phone"
                    rules={[
                      {
                        required: true,
                        message: "Số điện thoại không được để trống",
                      },
                      {
                        pattern: /^(03|05|07|08|09)\d{8}$/,
                        message: "Số điện thoại không hợp lệ",
                      },
                    ]}
                    className="mb-3"
                  >
                    <Input placeholder="Nhập số điện thoại..." />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Email"
                    name="email"
                    className="mb-3"
                    rules={[
                      {
                        required: true,
                        message: "Email không được để trống",
                      },
                      {
                        type: "email",
                        message: "Vui lòng nhập email đúng định dạng",
                      },
                    ]}
                  >
                    <Input placeholder="Nhập Email..." />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item label="Ghi chú đơn hàng" name="note" className="mb-3">
                <TextArea placeholder="Ghi chú đơn hàng..." rows={2} />
              </Form.Item>
              <Form.Item
                label=""
                name="invoice"
                className="mb-3"
                valuePropName="checked"
              >
                <Checkbox>Xuất hoá đơn</Checkbox>
              </Form.Item>
              <div className="text-[14px] text-[#D72F20] mb-3">
                Quý khách chỉ có thể yêu cầu xuất hoá đơn trong vòng 5 ngày kể
                từ ngày xuất vé
              </div>
              {invoice && (
                <Row gutter={8}>
                  <Col span={12}>
                    <Form.Item
                      name="taxCode"
                      className="mb-3"
                      label={
                        <div className="text-[14px]">Mã số thuế (VAT)</div>
                      }
                      rules={[
                        {
                          required: true,
                          message: "Mã số thuế không được để trống",
                        },
                      ]}
                    >
                      <Input placeholder="Mã số thuế..." />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      label={
                        <div className="text-[14px]">Người nhận hoá đơn</div>
                      }
                      name="receiverReceive"
                      className="mb-3"
                      rules={[
                        {
                          required: true,
                          message: "Người nhận hoá đơn không được để trống",
                        },
                      ]}
                    >
                      <Input placeholder="Nhập người nhận hoá đơn..." />
                    </Form.Item>
                  </Col>
                </Row>
              )}
            </div>
            <div
              style={{
                boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
              }}
              className=" bg-white p-4 text-[#0D1634] rounded-[20px] mb-3"
            >
              <div className="flex justify-between">
                <span className="font-semibold">Mã khuyến mãi</span>
                <div className="flex">
                  <Tag
                    onClick={() => setOpenVoucher(true)}
                    color={
                      voucherCode === "" && voucherValue === 0
                        ? "default"
                        : "success"
                    }
                    icon={<TagOutlined />}
                  >
                    {voucherCode === "" && voucherValue === 0
                      ? "Chọn mã giảm giá"
                      : voucherCode}
                  </Tag>
                  {voucherCode !== "" && voucherValue > 0 && (
                    <CloseOutlined
                      style={{ fontSize: 16, color: "red" }}
                      onClick={() => {
                        setVoucherCode("");
                        setVoucherValue(0);
                        setVoucherTxt("");
                        setTotalListPrice({
                          ...totalListPrice,
                          totalDisplay:
                            totalListPrice.totalFixed +
                            totalListPrice.baggage +
                            totalListPrice.baggage_out,
                        });
                      }}
                    />
                  )}
                </div>
              </div>
              {/* <div className="flex gap-1">
                <Input
                  onClick={() => setOpenVoucher(true)}
                  readOnly
                  placeholder="Nhập mã giảm giá"
                  value={voucherCode}
                />

                {voucherCode !== "" && voucherValue > 0 && (
                  <Button
                    onClick={() => {
                      setVoucherCode("");
                      setVoucherValue(0);
                      setVoucherTxt('');
                    }}
                    color="danger"
                    variant="solid"
                    size="large"
                  >
                    Huỷ
                  </Button>
                )}
              </div> */}
              {voucherTxt && (
                <div
                  className="mt-3"
                  dangerouslySetInnerHTML={{ __html: voucherTxt }}
                />
              )}
              <Drawer
                title={
                  <div className="flex flex-col gap-4">
                    <div className="flex justify-between">
                      <span className="uppercase font-bold tex-[20px]">
                        {" "}
                        Mã giảm giá của tôi
                      </span>
                      <CloseOutlined
                        onClick={() => setOpenVoucher(false)}
                        style={{ fontSize: 18, cursor: "pointer" }}
                      />
                    </div>
                    <div>
                      {/* <Input.Search
                        placeholder="Bạn có mã giảm giá khác"
                        enterButton={
                          <Button
                            type="primary"
                            style={{
                              backgroundColor: "#0064D2",
                              borderColor: "#0064D2",
                              color: "#FFFFFF",
                              fontWeight: "bold",
                            }}
                          >
                            Áp dụng
                          </Button>
                        }
                        allowClear
                        onChange={(e) => {
                          if (!e.target.value) {
                            setVoucherTxt("");
                            setVoucherValue(0);
                          }
                        }}
                        onSearch={applyVoucher}
                      /> */}
                      {voucherTxt && (
                        <div
                          className="mt-4"
                          dangerouslySetInnerHTML={{ __html: voucherTxt }}
                        />
                      )}
                    </div>
                  </div>
                }
                placement={"bottom"}
                closable={false}
                onClose={() => setOpenVoucher(false)}
                open={openVoucher}
                height={"100%"}
                bodyStyle={{
                  background: "#f3f6f6",
                }}
              >
                <div className="p-4">
                  {vouchers.map((voucher) => (
                    <div
                      style={{
                        boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                      }}
                      className=" rounded-[14px] bg-white p-3 mb-4"
                    >
                      <div className="flex gap-4 w-full">
                        <div className="w-1/5 flex items-center justify-center">
                          <img
                            src="/images/ve-may-bay.svg"
                            className="w-[32px]"
                            alt=""
                          />
                        </div>
                        <div className="border-lime-300 border-1 flex flex-col gap-1 flex-1">
                          <div className="font-semibold text-[16px] text-primary">
                            {" "}
                            Mã {voucher.code}
                          </div>
                          <div className="text-red-600 text-[14px] font-bold">
                            {voucher.title}
                          </div>{" "}
                          <div className="text-[14px]">
                            Áp dụng từ{" "}
                            {dayjs(voucher.startdate).format(
                              "HH:mm DD/MM/YYYY"
                            )}{" "}
                            đến{" "}
                            {dayjs(voucher.enddate).format("HH:mm DD/MM/YYYY")}
                          </div>
                          <div
                            onClick={() => applyVoucherPick(voucher)}
                            className="text-primary font-medium text-[14px] ml-auto"
                          >
                            Áp dụng
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </Drawer>
            </div>
          </Form>
          <Collapse
            bordered={false}
            expandIcon={null}
            defaultActiveKey={["1"]}
            className="bg-white custom-collapse"
            onChange={(e) => {
              setShowPriceDetail(e.length > 0);
            }}
            items={[
              {
                key: "1",
                showArrow: false,
                label: (
                  <div className="flex justify-between items-center">
                    <span className="text-[14px] font-medium mb-[12px]">
                      Tổng cộng (Thuế + Phí):
                    </span>
                    <div className="flex gap-1">
                      <span className="text-[16px] font-bold text-[#D72F20]">
                        {totalListPrice.totalDisplay.toLocaleString("vi-VN")} ₫
                      </span>
                      {showPriceDetail ? (
                        <CaretDownOutlined
                          style={{
                            fontSize: 14,
                          }}
                        />
                      ) : (
                        <CaretUpOutlined
                          style={{
                            fontSize: 14,
                          }}
                        />
                      )}
                    </div>
                  </div>
                ),
                children: (
                  <>
                    {chooseFlight.length === 2 && (
                      <div className="text-[12px] mb-2 font-medium">
                        Chiều đi
                      </div>
                    )}
                    <ul className="list-none">
                      {["adt", "chd", "inf"].map((type) => (
                        <>
                          {chooseFlight[0][type] > 0 && (
                            <li
                              key={type}
                              className="flex justify-between mb-2 text-[12px] text-[#5F5F67]"
                            >
                              <span className="w-2/6">
                                {type === "adt"
                                  ? "Vé người lớn"
                                  : type === "chd"
                                    ? "Vé trẻ em"
                                    : "Vé em bé"}
                                :
                              </span>
                              <span className="w-2/6 text-right">
                                {chooseFlight[0][type]} x{" "}
                                {chooseFlight[0][
                                  `fare${[type]}`
                                ].toLocaleString("vi-VN")}
                                đ
                              </span>
                            </li>
                          )}
                        </>
                      ))}
                      {chooseFlight[0].totaltax > 0 && (
                        <li className="flex justify-between mb-2 text-[12px] text-[#5F5F67]">
                          <span className="w-2/6">Thuế</span>
                          <span className="w-2/6 text-right"></span>
                          <span className="w-2/6 text-right">
                            {chooseFlight[0].totaltax.toLocaleString("vi-VN")} đ
                          </span>
                        </li>
                      )}
                      <li className="flex justify-between mb-2 text-[12px] text-[#5F5F67]">
                        <span className="w-2/6">Mua hành lý:</span>
                        <span className="w-2/6 text-right"></span>
                        <span className="w-2/6 text-right">
                          {" "}
                          {totalListPrice.baggage.toLocaleString("vi-VN")}đ
                        </span>
                      </li>
                    </ul>
                    {chooseFlight.length === 2 && (
                      <>
                        <div className="text-[12px] mb-2 font-medium">
                          Chiều về
                        </div>
                        <ul className="list-none">
                          {["adt", "chd", "inf"].map((type) => (
                            <>
                              {chooseFlight[1][type] > 0 && (
                                <li
                                  key={type}
                                  className="flex justify-between mb-2 text-[12px] text-[#5F5F67]"
                                >
                                  <span className="w-2/6">
                                    {chooseFlight[1][type] > 0 &&
                                      (type === "adt"
                                        ? "Vé người lớn"
                                        : type === "chd"
                                          ? "Vé trẻ em"
                                          : "Vé em bé")}
                                    :
                                  </span>
                                  <span className="w-2/6 text-right">
                                    {chooseFlight[1][type]} x{" "}
                                    {chooseFlight[1][
                                      `fare${[type]}`
                                    ].toLocaleString("vi-VN")}
                                    đ
                                  </span>
                                </li>
                              )}
                            </>
                          ))}
                          {chooseFlight[1].totaltax > 0 && (
                            <li className="flex justify-between mb-2 text-[12px] text-[#5F5F67]">
                              <span className="w-2/6">Thuế</span>
                              <span className="w-2/6 text-right"></span>
                              <span className="w-2/6 text-right">
                                {chooseFlight[1].totaltax.toLocaleString(
                                  "vi-VN"
                                )}{" "}
                                đ
                              </span>
                            </li>
                          )}
                          <li className="flex justify-between mb-2 text-[12px] text-[#5F5F67]">
                            <span className="w-2/6">Mua hành lý:</span>
                            <span className="w-2/6 text-right"></span>
                            <span className="w-2/6 text-right">
                              {totalListPrice.baggage_out.toLocaleString(
                                "vi-VN"
                              )}{" "}
                              đ
                            </span>
                          </li>
                        </ul>
                      </>
                    )}
                    {voucherCode !== "" && voucherValue > 0 && (
                      <ul className="list-none">
                        <li className="flex justify-between mb-2 text-[12px] text-[#5F5F67]">
                          <span className="w-2/6">Giảm giá:</span>
                          <span className="w-2/6 text-right"></span>
                          <span className="w-2/6 text-right text-green-600">
                            {voucherValue.toLocaleString("vi-VN")} đ
                          </span>
                        </li>
                      </ul>
                    )}
                  </>
                ),
              },
            ]}
          />
        </div>
      </div>
      <div className="fixed bottom-0 w-full">
        <div className="flex justify-between bg-white p-4 w-full">
          <Button
            onClick={handleBackClick}
            className="w-[45%] h-[45px] rounded-[10px] text-center mx-auto bg-white text-primary text-[15px] border-primary"
          >
            <span className="font-semibold">Quay lại</span>
          </Button>
          <Button
            type="primary"
            onClick={() => {
              formRef.current.submit();
            }}
            className="w-[45%] h-[45px] rounded-[10px] text-center mx-auto text-white text-[15px]"
          >
            <span className="font-semibold">Tiếp tục</span>
          </Button>
        </div>
        <ConfirmModal
          visible={isModalConfirm}
          onClose={() => {
            setIsModalConfirm(false);
          }}
          data={bodyBooking}
          onOk={() => {
            setIsModalConfirm(false);
            handlePayment();
          }}
        />
        <RepaymentModal
          visible={openRepaymentModal}
          airports={airports}
          onClose={() => {
            setOpenRepaymentModal(false);
          }}
          isRepayment={false}
          data={dataRepayment}
        />
      </div>
      {contextHolder}
    </div>
  );
};

export default Step3;